import service from '@/services/linkShops';

export default {
  fetchShopLinks: context => {
    context.commit('setLoadingLinks', true);
    return service.getShopLinks().then(res => {
      context.commit('setShopLinks', res.data);
      context.commit('setLoadingLinks', false);
    });
  },
  removeShopLink: (context, payload) => {
    return service.deleteShopLink(payload).then(() => {
      const index = context.state.shopLinks.findIndex(
        shopLink => shopLink.shopLinkedFromId === payload
      );
      context.commit('removeShopLink', index);
    });
  },
  addShopLink: (context, payload) => {
    return service.createShopLink(payload);
  },
};
